import { Routes } from '@angular/router';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'queue-view', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then(m => m.HomePage),
  },
  {
    path: 'booking',
    loadComponent: () => import('./pages/booking/booking.page').then(m => m.BookingPage),
  },
  {
    path: 'confirmation',
    loadComponent: () => import('./pages/confirmation/confirmation.page').then(m => m.ConfirmationPage),
  },
  {
    path: 'my-queue',
    loadComponent: () => import('./pages/my-queue/my-queue.page').then(m => m.MyQueuePage),
  },
  {
    path: 'queue-view',
    loadComponent: () => import('./pages/queue-view/queue-view.page').then(m => m.QueueViewPage),
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin/admin-login/admin-login.page').then(m => m.AdminLoginPage),
  },
  {
    path: 'admin/queue',
    canActivate: [adminGuard],
    loadComponent: () => import('./pages/admin/admin-queue/admin-queue.page').then(m => m.AdminQueuePage),
  },
];
